import OneTimePasswordForm from "./OneTimePasswordForm";

export default OneTimePasswordForm;
